import { http } from '@/services/http_service';
export default {

    //친구목록 가져오기
    getFriends(context,data)
    {
        return http()
        .post("/friend/friendList?page="+data.page,data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log('getMessages',response.data.messages.data)
            //context.commit('setItemView', response.data)
            console.log(response);
            // if(data.page ===1)스크롤해서 불러 오는 방식에서 일반 테이블 형식으로 수정
            // {
            //     context.commit('setMessageInit', response.data.messages.data)
            // }else{
            //     context.commit('setMessage', response.data.messages.data)
            // }
            context.commit('setFriendInit', response.data.friends)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    //추천인 리스트 가져오기
    getRecommenderList(context,data)
    {
        return http()
        .post("/friend/recommenderList?page="+data.page,data)//user_id
        .then((response) => {           
            //console.log(response);           
            context.commit('setRecommendInit', response.data.recommenders)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    //친구등록
    addFriend(context,data)
    {
        return http()
        .post("/friend/contract",data)
        .then((response) => {
            //context.commit('updateItemBuy', response.data.itemBuy)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    

}
